/**
 * Topicless LiveKit data messages the video backend sends to every
 * participant in a room (core.utils.notify_participants). One place for the
 * type strings so the frontend cannot drift from the backend settings.
 */

/** A guest asked to enter (backend LOBBY_NOTIFICATION_TYPE). */
export const PARTICIPANT_WAITING_TYPE = "participantWaiting";

/** The room's admit_policy changed mid-call (backend
 *  ADMIT_POLICY_NOTIFICATION_TYPE). Payload carries the new `admit_policy`. */
export const ADMIT_POLICY_CHANGED_TYPE = "admitPolicyChanged";

/** A waiting participant was admitted (backend
 *  LOBBY_ADMITTED_NOTIFICATION_TYPE, #1916). Payload carries participant_id,
 *  identity, username and admitted_by. */
export const PARTICIPANT_ADMITTED_TYPE = "participantAdmitted";

/** Sent by the backend to the evicted identity ONLY, just before a
 *  cross-room eviction (backend JOINED_OTHER_ROOM_NOTIFICATION_TYPE, #1918).
 *  Payload carries `room_name` — the call the same account just joined. */
export const JOINED_OTHER_ROOM_TYPE = "joinedOtherRoom";

/** Policy value that lets anyone in the call manage the waiting list. */
export const ADMIT_POLICY_PARTICIPANTS = "participants";

export interface RoomDataMessage {
  type?: unknown;
  admit_policy?: unknown;
  participant_id?: unknown;
  identity?: unknown;
  username?: unknown;
  admitted_by?: unknown;
  room_name?: unknown;
}

/** Decode a data-channel payload as JSON; null for anything else (other
 *  hooks broadcast non-JSON or unrelated messages on the same channel). */
export function parseRoomDataMessage(
  decoder: TextDecoder,
  payload: Uint8Array,
): RoomDataMessage | null {
  try {
    const data: unknown = JSON.parse(decoder.decode(payload));
    return data && typeof data === "object" ? (data as RoomDataMessage) : null;
  } catch {
    return null;
  }
}
